/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddAssetTypeSubsystemMappingRequestDto,
  AssetTypeSubsystemMappingResponseDto,
  RemoveAssetTypeSubsystemMappingRequestDto,
  SetAssetTypesForSubsystemRequestDto,
  SetSubsystemsForAssetTypeRequestDto,
} from '../models/index';
import {
    AddAssetTypeSubsystemMappingRequestDtoFromJSON,
    AddAssetTypeSubsystemMappingRequestDtoToJSON,
    AssetTypeSubsystemMappingResponseDtoFromJSON,
    AssetTypeSubsystemMappingResponseDtoToJSON,
    RemoveAssetTypeSubsystemMappingRequestDtoFromJSON,
    RemoveAssetTypeSubsystemMappingRequestDtoToJSON,
    SetAssetTypesForSubsystemRequestDtoFromJSON,
    SetAssetTypesForSubsystemRequestDtoToJSON,
    SetSubsystemsForAssetTypeRequestDtoFromJSON,
    SetSubsystemsForAssetTypeRequestDtoToJSON,
} from '../models/index';

export interface AssetSubsystemMappingControllerAddMappingRequest {
    addAssetTypeSubsystemMappingRequestDto: AddAssetTypeSubsystemMappingRequestDto;
}

export interface AssetSubsystemMappingControllerGetAssetTypesForSubsystemRequest {
    subsystemId: string;
}

export interface AssetSubsystemMappingControllerGetSubsystemsForAssetTypeRequest {
    assetTypeId: string;
}

export interface AssetSubsystemMappingControllerRemoveMappingRequest {
    removeAssetTypeSubsystemMappingRequestDto: RemoveAssetTypeSubsystemMappingRequestDto;
}

export interface AssetSubsystemMappingControllerSetAssetTypesForSubsystemRequest {
    subsystemId: string;
    setAssetTypesForSubsystemRequestDto: SetAssetTypesForSubsystemRequestDto;
}

export interface AssetSubsystemMappingControllerSetSubsystemsForAssetTypeRequest {
    assetTypeId: string;
    setSubsystemsForAssetTypeRequestDto: SetSubsystemsForAssetTypeRequestDto;
}

/**
 * 
 */
export class KnowledgeBaseAssetSubsystemMappingsApi extends runtime.BaseAPI {

    /**
     */
    async assetSubsystemMappingControllerAddMappingRaw(requestParameters: AssetSubsystemMappingControllerAddMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['addAssetTypeSubsystemMappingRequestDto'] == null) {
            throw new runtime.RequiredError(
                'addAssetTypeSubsystemMappingRequestDto',
                'Required parameter "addAssetTypeSubsystemMappingRequestDto" was null or undefined when calling assetSubsystemMappingControllerAddMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddAssetTypeSubsystemMappingRequestDtoToJSON(requestParameters['addAssetTypeSubsystemMappingRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetSubsystemMappingControllerAddMapping(requestParameters: AssetSubsystemMappingControllerAddMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetSubsystemMappingControllerAddMappingRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assetSubsystemMappingControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetTypeSubsystemMappingResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetTypeSubsystemMappingResponseDtoFromJSON));
    }

    /**
     */
    async assetSubsystemMappingControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetTypeSubsystemMappingResponseDto>> {
        const response = await this.assetSubsystemMappingControllerFindAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async assetSubsystemMappingControllerGetAssetTypesForSubsystemRaw(requestParameters: AssetSubsystemMappingControllerGetAssetTypesForSubsystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetTypeSubsystemMappingResponseDto>>> {
        if (requestParameters['subsystemId'] == null) {
            throw new runtime.RequiredError(
                'subsystemId',
                'Required parameter "subsystemId" was null or undefined when calling assetSubsystemMappingControllerGetAssetTypesForSubsystem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem/by-subsystem/{subsystemId}`;
        urlPath = urlPath.replace(`{${"subsystemId"}}`, encodeURIComponent(String(requestParameters['subsystemId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetTypeSubsystemMappingResponseDtoFromJSON));
    }

    /**
     */
    async assetSubsystemMappingControllerGetAssetTypesForSubsystem(requestParameters: AssetSubsystemMappingControllerGetAssetTypesForSubsystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetTypeSubsystemMappingResponseDto>> {
        const response = await this.assetSubsystemMappingControllerGetAssetTypesForSubsystemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetSubsystemMappingControllerGetSubsystemsForAssetTypeRaw(requestParameters: AssetSubsystemMappingControllerGetSubsystemsForAssetTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssetTypeSubsystemMappingResponseDto>>> {
        if (requestParameters['assetTypeId'] == null) {
            throw new runtime.RequiredError(
                'assetTypeId',
                'Required parameter "assetTypeId" was null or undefined when calling assetSubsystemMappingControllerGetSubsystemsForAssetType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem/by-asset-type/{assetTypeId}`;
        urlPath = urlPath.replace(`{${"assetTypeId"}}`, encodeURIComponent(String(requestParameters['assetTypeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssetTypeSubsystemMappingResponseDtoFromJSON));
    }

    /**
     */
    async assetSubsystemMappingControllerGetSubsystemsForAssetType(requestParameters: AssetSubsystemMappingControllerGetSubsystemsForAssetTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssetTypeSubsystemMappingResponseDto>> {
        const response = await this.assetSubsystemMappingControllerGetSubsystemsForAssetTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async assetSubsystemMappingControllerRemoveMappingRaw(requestParameters: AssetSubsystemMappingControllerRemoveMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['removeAssetTypeSubsystemMappingRequestDto'] == null) {
            throw new runtime.RequiredError(
                'removeAssetTypeSubsystemMappingRequestDto',
                'Required parameter "removeAssetTypeSubsystemMappingRequestDto" was null or undefined when calling assetSubsystemMappingControllerRemoveMapping().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveAssetTypeSubsystemMappingRequestDtoToJSON(requestParameters['removeAssetTypeSubsystemMappingRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetSubsystemMappingControllerRemoveMapping(requestParameters: AssetSubsystemMappingControllerRemoveMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetSubsystemMappingControllerRemoveMappingRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assetSubsystemMappingControllerSetAssetTypesForSubsystemRaw(requestParameters: AssetSubsystemMappingControllerSetAssetTypesForSubsystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subsystemId'] == null) {
            throw new runtime.RequiredError(
                'subsystemId',
                'Required parameter "subsystemId" was null or undefined when calling assetSubsystemMappingControllerSetAssetTypesForSubsystem().'
            );
        }

        if (requestParameters['setAssetTypesForSubsystemRequestDto'] == null) {
            throw new runtime.RequiredError(
                'setAssetTypesForSubsystemRequestDto',
                'Required parameter "setAssetTypesForSubsystemRequestDto" was null or undefined when calling assetSubsystemMappingControllerSetAssetTypesForSubsystem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem/by-subsystem/{subsystemId}/asset-types`;
        urlPath = urlPath.replace(`{${"subsystemId"}}`, encodeURIComponent(String(requestParameters['subsystemId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetAssetTypesForSubsystemRequestDtoToJSON(requestParameters['setAssetTypesForSubsystemRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetSubsystemMappingControllerSetAssetTypesForSubsystem(requestParameters: AssetSubsystemMappingControllerSetAssetTypesForSubsystemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetSubsystemMappingControllerSetAssetTypesForSubsystemRaw(requestParameters, initOverrides);
    }

    /**
     */
    async assetSubsystemMappingControllerSetSubsystemsForAssetTypeRaw(requestParameters: AssetSubsystemMappingControllerSetSubsystemsForAssetTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assetTypeId'] == null) {
            throw new runtime.RequiredError(
                'assetTypeId',
                'Required parameter "assetTypeId" was null or undefined when calling assetSubsystemMappingControllerSetSubsystemsForAssetType().'
            );
        }

        if (requestParameters['setSubsystemsForAssetTypeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'setSubsystemsForAssetTypeRequestDto',
                'Required parameter "setSubsystemsForAssetTypeRequestDto" was null or undefined when calling assetSubsystemMappingControllerSetSubsystemsForAssetType().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/asset-subsystem/by-asset-type/{assetTypeId}/subsystems`;
        urlPath = urlPath.replace(`{${"assetTypeId"}}`, encodeURIComponent(String(requestParameters['assetTypeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetSubsystemsForAssetTypeRequestDtoToJSON(requestParameters['setSubsystemsForAssetTypeRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async assetSubsystemMappingControllerSetSubsystemsForAssetType(requestParameters: AssetSubsystemMappingControllerSetSubsystemsForAssetTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assetSubsystemMappingControllerSetSubsystemsForAssetTypeRaw(requestParameters, initOverrides);
    }

}
